/** Copyright (c) 2022-present TVM Engineering Authors. */

export default {
  DEVICE_ONLINE: "APP/DEVICE_ONLINE",
  DEVICE_IS_LOADING: "APP/DEVICE_IS_LOADING",
  SET_NEW_VERSION_AVAILABLE: "APP/SET_NEW_VERSION_AVAILABLE",
  SET_SIDE_BAR_OPENED: "APP/SET_SIDE_BAR_OPENED",
  SIGN_IN: "APP/SIGN_IN",
  SIGN_IN_ERROR: "APP/SIGN_IN_ERROR",
  DEVICE_OFFLINE: "APP/DEVICE_OFFLINE",
  SET_NOTIFICATION_STATUS: "APP/SET_NOTIFICATION_STATUS",
  SET_NOTIFICATION: "APP/SET_NOTIFICATION",
  SET_LANGUAGE: "APP/SET_LANGUAGE",
  SET_COUNTRY: "APP/SET_COUNTRY",
  SET_DISPLAYSIZING: "APP/SET_DISPLAYSIZING",
  LOGIN_REQUEST: "APP/LOGIN_REQUEST",
  LOGIN_SUCCESS: "APP/LOGIN_SUCCESS",
  LOGIN_FAILURE: "APP/LOGIN_FAILURE",
  LOGOUT: "APP/LOGOUT",
  INVITE_USER: "APP/INVITE_USER",
  SET_COOKIES: "APP/SET_PRIVACY_POLICY_READ",
  SET_ROUTES: "APP/SET_ROUTES",
  // Auth Actions
  AUTH_USER: "APP/AUTH_USER",
  UNAUTH_USER: "APP/UNAUTH_USER",
  AUTH_ERROR: "APP/AUTH_ERROR",
  FORGOT_PASSWORD_REQUEST: "APP/FORGOT_PASSWORD_REQUEST",
  RESET_PASSWORD_REQUEST: "APP/RESET_PASSWORD_REQUEST",
  PROTECTED_TEST: "APP/PROTECTED_TEST",
  ERROR_RESPONSE: "APP/ERROR_RESPONSE",
  // User Profile Actions
  FETCH_USER: "APP/FETCH_USER",
  FETCH_UPDATE_PASSWORD: "APP/FETCH_UPDATE_PASSWORD",
  // PROJECTS
  FETCH_PROJECT: "FETCH_PROJECT",
  GET_ALL_PROJECTS: "GET_ALL_PROJECTS",
  GET_PROJECTS_BY_USER_ID: "GET_PROJECTS_BY_USER_ID",
  FETCH_CREATE_PROJECT: "FETCH_CREATE_PROJECT",
  FETCH_ARCHIVED_PROJECTS: "FETCH_ARCHIVED_PROJECTS",
  FETCH_UPDATE_PROJECT: "FETCH_UPDATE_PROJECT",
  FETCH_DELETE_PROJECT: "FETCH_DELETE_PROJECT",
  // Admin
  FETCH_ALL_USERS: "APP/FETCH_ALL_USERS",
  FETCH_CREATE_USER: "APP/FETCH_CREATE_USER",
  FETCH_USER_ACTIVATION: "APP/FETCH_USER_ACTIVATION",
  SET_USER_ROLE: "APP/SET_USER_ROLE",
  UPDATE_USER: "APP/UPDATE_USER",
  REMOVE_USER: "APP/REMOVE_USER",
  GET_USER: "APP/GET_USER",
  // SEARCH QUERY
  FETCH_SEARCH_QUERY: "APP/FETCH_SEARCH_QUERY",
  // Page Actions
  SEND_CONTACT_FORM: "APP/SEND_CONTACT_FORM",
  STATIC_ERROR: "APP/STATIC_ERROR",
  // Toggle Dialogs
  TOGGLE_ADD_USER_DIALOG: "APP/TOGGLE_ADD_USER_DIALOG",
  TOGGLE_EDIT_USER_DIALOG: "APP/TOGGLE_EDIT_USER_DIALOG",
  TOGGLE_ADD_PROJECT_DIALOG: "APP/TOGGLE_ADD_PROJECT_DIALOG",
  TOGGLE_EDIT_PROJECT_DIALOG: "APP/TOGGLE_EDIT_PROJECT_DIALOG",
  TOGGLE_INVITE_USER_DIALOG: "APP/TOGGLE_INVITE_USER_DIALOG",
  TOGGLE_SETTINGS_DIALOG: "APP/TOGGLE_SETTINGS_DIALOG",
  TOGGLE_CREATE_UPDATE_PROJECT_DIALOG: "APP/TOGGLE_CREATE_UPDATE_PROJECT_DIALOG",
  TOGGLE_LEARN_MORE_DIALOG: "APP/TOGGLE_LEARN_MORE_DIALOG",
  TOGGLE_LICENSE_DIALOG: "APP/TOGGLE_LICENSE_DIALOG",
  TOGGLE_WORKER_DIALOG: "APP/TOGGLE_WORKER_DIALOG",
  TOGGLE_JOBS_ERRORS_DIALOG: "APP/TOGGLE_JOBS_ERRORS_DIALOG",
  // TOOLS
  GET_ALL_TOOLS: "GET_ALL_TOO_PROJECTLS",
  GET_ALL_TOOLS_BY_PROJECT_ID: "GET_ALL_TOOLS_BY_PROJECT_ID",
  // TERMS_AND_CONDITIONS
  GET_ALL_TERMS_AND_CONDITIONS: "GET_ALL_TERMS_AND_CONDITIONS",
  // TERMS_VERSION
  GET_ALL_TERMS_VERSION: "GET_ALL_TERMS_VERSION",
  // AVAILABLE TOOLS
  GET_ALL_UPLOADS: "GET_ALL_UPLOADS",
  GET_SINGLE_COMPANY_FILES: "GET_SINGLE_COMPANY_FILES",
  GET_MULTIPLE_COMPANY_FILES: "GET_MULTIPLE_COMPANY_FILES",
  SET_FILES: "SET_FILES",
  SET_FILES_TERMS: "SET_FILES_AND_TERMS",
  SET_FILES_FOR_DOWNLOAD: "SET_FILES_FOR_DOWNLOAD",
  SET_UPLOAD_TYPE: "SET UPLOAD TYPE",
  GET_COMPANIES: "GET_COMPANIES",
};
